
export enum UserRoleEnum {
    OrganisationAdmin = "COMPANY_ADMIN",
    OrganisationViewer = "COMPANY_VIEWER",
    SuperAdmin = "SUPER_ADMIN",
}
